
module Tapas.Bindings {
    export class LoadOnBool {
        public update(element: any, valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var load = bindingContext.$root.load();

			if (ko.unwrap(valueAccessor().observableBool)) {
				load.active(true);
				load.text(valueAccessor().text);
			}
			else {
				load.active(false);
				load.text("");
			}

			$(window).unload(function () {
				load.active(false);
			});
        }
    }
    ko.bindingHandlers['loadOnBool'] = new LoadOnBool();
} 
